import { useSelector } from 'react-redux'

import { useGetPlan } from '@/app/module/plans/hooks/use-get-plan'
import { selectActiveOrg, selectUserPermissions } from '@/app/module/user/store/selectors'
import { Organization, Permissions } from '@/app/types'

export const useRequirePermission = (permission: keyof Permissions) => {
  const userPermissions = useSelector(selectUserPermissions) as Permissions | undefined
  return !!userPermissions?.[permission]
}

export const useShowCanceled = () => {
  const org = useSelector(selectActiveOrg)
  const { data: plan } = useGetPlan()

  if (!org || !plan || !(org as Organization).permissions.manageUsers) {
    return false
  }

  return plan.canceled && !!plan.end
}
